import '@/styles/main.scss'

import type { IconSet, IconProps } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'

// TODO: Refactor our custom icons

import AddSmall from '@/components/icons/AddSmall.vue'
import Address from '@/components/icons/Address.vue'
import Aadd from '@/components/icons/Aadd.vue'
import AChat from '@/components/icons/AChat.vue'
import AccountDisabled from '@/components/icons/AccountDisabled.vue'
import AddPerson from '@/components/icons/AddPerson.vue'
import Adelete from '@/components/icons/Adelete.vue'
import AdminGuide from '@/components/icons/AdminGuide.vue'
import AEdit from '@/components/icons/AEdit.vue'
import Archive from '@/components/icons/Archive.vue'
import ArrowUp from '@/components/icons/ArrowUp.vue'
import ArrowUpRight from '@/components/icons/ArrowUpRight.vue'
import ArrowDown from '@/components/icons/ArrowDown.vue'
import ArrowFirstPage from '@/components/icons/ArrowFirstPage.vue'
import ArrowLastPage from '@/components/icons/ArrowLastPage.vue'
import ArrowRight from '@/components/icons/ArrowRight.vue'
import ArrowLong from '@/components/icons/ArrowLong.vue'
import Artboard from '@/components/icons/Artboard.vue'
import AStar from '@/components/icons/AStar.vue'
import AStarRemove from '@/components/icons/AStarRemove.vue'
import ASync from '@/components/icons/ASync.vue'
import At from '@/components/icons/At.vue'
import Attachment from '@/components/icons/Attachment.vue'
import AttachmentsSettings from '@/components/icons/AttachmentsSettings.vue'
import AutoDelete from '@/components/icons/AutoDelete.vue'
import BackToDesktop from '@/components/icons/BackToDesktop.vue'
import Ban from '@/components/icons/Ban.vue'
import Bank from '@/components/icons/Bank.vue'
import BankIdent from '@/components/icons/BankIdent.vue'
import Bell from '@/components/icons/Bell.vue'
import Bin from '@/components/icons/Bin.vue'
import BrowserRedirect from '@/components/icons/BrowserRedirect.vue'
import Bullet from '@/components/icons/Bullet.vue'
import BusinessAccount from '@/components/icons/BusinessAccount.vue'
import BusinessAES from '@/components/icons/BusinessAES.vue'
import BusinessDocs from '@/components/icons/BusinessDocs.vue'
import BusinessProfile from '@/components/icons/BusinessProfile.vue'
import Cached from '@/components/icons/Cached.vue'
import CAdd from '@/components/icons/CAdd.vue'
import CAddFull from '@/components/icons/CAddFull.vue'
import CAddOutline from '@/components/icons/CAddOutline.vue'
import CAddSmall from '@/components/icons/CAddSmall.vue'
import Card from '@/components/icons/Card.vue'
import CalendarDate from '@/components/icons/CalendarDate.vue'
import Cancel from '@/components/icons/Cancel.vue'
import CardUpdate from '@/components/icons/CardUpdate.vue'
import Changelog from '@/components/icons/Changelog.vue'
import CCheck from '@/components/icons/CCheck.vue'
import CCheckBig from '@/components/icons/CCheckBig.vue'
import CCheckmarkBigCircle from '@/components/icons/CCheckmarkBig.vue'
import CClose from '@/components/icons/CClose.vue'
import Check from '@/components/icons/Check.vue'
import CheckboxActive from '@/components/icons/CheckboxActive.vue'
import CheckboxInactive from '@/components/icons/CheckboxInactive.vue'
import CheckboxIndeterminate from '@/components/icons/CheckboxIndeterminate.vue'
import CheckSmall from '@/components/icons/CheckSmall.vue'
import ChopCircle from '@/components/icons/ChopCircle.vue'
import ChopCircleFull from '@/components/icons/ChopCircleFull.vue'
import CircleDot from '@/components/icons/CircleDot.vue'
import CircleProfile from '@/components/icons/CircleProfile.vue'
import CircleSimpleUp from '@/components/icons/CircleSimpleUp.vue'
import Clear from '@/components/icons/Clear.vue'
import ClearOutline from '@/components/icons/ClearOutline.vue'
import ClearSmall from '@/components/icons/ClearSmall.vue'
import Clock from '@/components/icons/Clock.vue'
import ChevronUp from '@/components/icons/ChevronUp.vue'
import CloseX from '@/components/icons/CloseX.vue'
import ContactEmail from '@/components/icons/ContactEmail.vue'
import ContinueSR from '@/components/icons/ContinueSR.vue'
import Copy from '@/components/icons/Copy.vue'
import CopyContent from '@/components/icons/CopyContent.vue'
import CopySr from '@/components/icons/CopySr.vue'
import CouponTag from '@/components/icons/CouponTag.vue'
import CQuestion from '@/components/icons/CQuestion.vue'
import CreditCard from '@/components/icons/CreditCard.vue'
import CsvFile from '@/components/icons/CsvFile.vue'
import CurrencyExchange from '@/components/icons/CurrencyExchange.vue'
import DataDownload from '@/components/icons/DataDownload.vue'
import DataDownloadOutline from '@/components/icons/DataDownloadOutline.vue'
import Delegate from '@/components/icons/Delegate.vue'
import DelegateUser from '@/components/icons/DelegateUser.vue'
import Design from '@/components/icons/Design.vue'
import Developers from '@/components/icons/Developers.vue'
import Document from '@/components/icons/Document.vue'
import DocumentOutline from '@/components/icons/DocumentOutline.vue'
import DocumentSearch from '@/components/icons/DocumentSearch.vue'
import DocumentPage from '@/components/icons/IconDocumentPage.vue'
import DocumentToSign from '@/components/icons/DocumentToSign.vue'
import Dots from '@/components/icons/Dots.vue'
import Draft from '@/components/icons/Draft.vue'
import DraftsEmpty from '@/components/icons/DraftsEmpty.vue'
import Eidplus from '@/components/icons/Eidplus.vue'
import Email from '@/components/icons/Email.vue'
import EmailSettingsAll from '@/components/icons/EmailSettingsAll.vue'
import EmailSettingsImportant from '@/components/icons/EmailSettingsImportant.vue'
import EmailSettingsNone from '@/components/icons/EmailSettingsNone.vue'
import Enter from '@/components/icons/Enter.vue'
import ERemove from '@/components/icons/ERemove.vue'
import ExpandClose from '@/components/icons/ExpandClose.vue'
import ExpandMore from '@/components/icons/ExpandMore.vue'
import ExpandOpen from '@/components/icons/ExpandOpen.vue'
import EyeOpen from '@/components/icons/EyeOpen.vue'
import EZug from '@/components/icons/EZug.vue'
import FDashboard from '@/components/icons/FDashboard.vue'
import FileText from '@/components/icons/FileText.vue'
import Filter from '@/components/icons/Filter.vue'
import FitHeight from '@/components/icons/FitHeight.vue'
import FitWidth from '@/components/icons/FitWidth.vue'
import FolderUser from '@/components/icons/FolderUser.vue'
import FreeToSign from '@/components/icons/FreeToSign.vue'
import Gear from '@/components/icons/Gear.vue'
import Google from '@/components/icons/Google.vue'
import GoToSkribble from '@/components/icons/GoToSkribble.vue'
import Grid from '@/components/icons/Grid.vue'
import HappyEmoticon from '@/components/icons/HappyEmoticon.vue'
import HelpCenter from '@/components/icons/HelpCenter.vue'
import HelpCircle from '@/components/icons/HelpCircle.vue'
import HighlightOff from '@/components/icons/HighlightOff.vue'
import IcMoreHorizontal from '@/components/icons/IcMoreHorizontal.vue'
import IconDummy from '@/components/icons/IconDummy.vue'
import IconFeedback from '@/components/icons/IconFeedback.vue'
import IconVisibility from '@/components/icons/IconVisibility.vue'
import IconVisibilityOff from '@/components/icons/IconVisibilityOff.vue'
import Ident from '@/components/icons/Ident.vue'
import InboxEmpty from '@/components/icons/InboxEmpty.vue'
import Info from '@/components/icons/Info.vue'
import InfoSolid from '@/components/icons/InfoSolid.vue'
import Integration from '@/components/icons/Integration.vue'
import Invoice from '@/components/icons/Invoice.vue'
import InvoiceDownload from '@/components/icons/InvoiceDownload.vue'
import KeyboardArrowDown from '@/components/icons/KeyboardArrowDown.vue'
import LastChange from '@/components/icons/LastChange.vue'
import Label from '@/components/icons/Label.vue'
import Leave from '@/components/icons/Leave.vue'
import LightningBig from '@/components/icons/LightningBig.vue'
import List from '@/components/icons/List.vue'
import Loudspeaker from '@/components/icons/Loudspeaker.vue'
import Magnify from '@/components/icons/Magnify.vue'
import MagnifyOutline from '@/components/icons/MagnifyOutline.vue'
import Mail from '@/components/icons/Mail.vue'
import Menu from '@/components/icons/Menu.vue'
import Microsoft from '@/components/icons/Microsoft.vue'
import MinusCircle from '@/components/icons/MinusCircle.vue'
import MobileContact from '@/components/icons/MobileContact.vue'
import MoreVert from '@/components/icons/MoreVert.vue'
import MoreVertSmall from '@/components/icons/MoreVertSmall.vue'
import Multiple from '@/components/icons/Multiple.vue'
import NeutralEmoticon from '@/components/icons/NeutralEmoticon.vue'
import NewBtnDesktop from '@/components/icons/NewBtnDesktop.vue'
import NewBtnMobile from '@/components/icons/NewBtnMobile.vue'
import NextSignature from '@/components/icons/NextSignature.vue'
import NoCreditCard from '@/components/icons/NoCreditCard.vue'
import Observer from '@/components/icons/Observer.vue'
import Option from '@/components/icons/Option.vue'
import OpenInNew from '@/components/icons/OpenInNew.vue'
import Padlock from '@/components/icons/Padlock.vue'
import PadlockSquare from '@/components/icons/PadlockSquare.vue'
import PaymentMethod from '@/components/icons/PaymentMethod.vue'
import PayToSign from '@/components/icons/PayToSign.vue'
import PaymentCard from '@/components/icons/PaymentCard.vue'
import Pencil from '@/components/icons/Pencil.vue'
import PersonCheck from '@/components/icons/PersonCheck.vue'
import PersonRemove from '@/components/icons/PersonRemove.vue'
import PersonSeveral from '@/components/icons/PersonSeveral.vue'
import PersonSingle from '@/components/icons/PersonSingle.vue'
import Photo from '@/components/icons/Photo.vue'
import ProPlan from '@/components/icons/ProPlan.vue'
import RadioButtonActive from '@/components/icons/RadioButtonActive.vue'
import RadioButtonInactive from '@/components/icons/RadioButtonInactive.vue'
import Referral from '@/components/icons/Referral.vue'
import Refresh from '@/components/icons/Refresh.vue'
import Remove from '@/components/icons/Remove.vue'
import Replace from '@/components/icons/Replace.vue'
import Reply from '@/components/icons/Reply.vue'
import Reset from '@/components/icons/Reset.vue'
import RulerPen from '@/components/icons/RulerPen.vue'
import SadEmoticon from '@/components/icons/SadEmoticon.vue'
import Seal from '@/components/icons/Seal.vue'
import Search from '@/components/icons/Search.vue'
import SearchError from '@/components/icons/SearchError.vue'
import SearchNotFound from '@/components/icons/SearchNotFound.vue'
import SeatFull from '@/components/icons/SeatFull.vue'
import SeatSigner from '@/components/icons/SeatSigner.vue'
import Security from '@/components/icons/Security.vue'
import SendMessage from '@/components/icons/SendMessage.vue'
import SetupMoney from '@/components/icons/SetupMoney.vue'
import SetupOptions from '@/components/icons/SetupOptions.vue'
import Signature from '@/components/icons/Signature.vue'
import SignatureCrossed from '@/components/icons/SignatureCrossed.vue'
import SignatureStandards from '@/components/icons/SignatureStandards.vue'
import SigningFailure from '@/components/icons/SigningFailure.vue'
import SingleCopy from '@/components/icons/SingleCopy.vue'
import SortArrow from '@/components/icons/SortArrow.vue'
import Square from '@/components/icons/Square.vue'
import StarterPlan from '@/components/icons/StarterPlan.vue'
import Summary from '@/components/icons/Summary.vue'
import SupportHotline from '@/components/icons/SupportHotline.vue'
import Sparkles from '@/components/icons/Sparkles.vue'
import Swissid from '@/components/icons/Swissid.vue'
import SystemPreferences from '@/components/icons/SystemPreferences.vue'
import ToSign from '@/components/icons/ToSign.vue'
import TrustId from '@/components/icons/TrustId.vue'
import TeamPlan from '@/components/icons/TeamPlan.vue'
import Ungroup from '@/components/icons/Ungroup.vue'
import UpgradeArrow from '@/components/icons/UpgradeArrow.vue'
import UsersGroup from '@/components/icons/UsersGroup.vue'
import UsersAdd from '@/components/icons/UsersAdd.vue'
import UserEdit from '@/components/icons/IconUserEdit.vue'
import VerificationDocument from '@/components/icons/VerificationDocument.vue'
import VideoPlay from '@/components/icons/VideoPlay.vue'
import VideoTutorials from '@/components/icons/VideoTutorials.vue'
import Wallet from '@/components/icons/Wallet.vue'
import Warning from '@/components/icons/Warning.vue'
import Withdraw from '@/components/icons/Withdraw.vue'
import Zoom from '@/components/icons/Zoom.vue'
import ZoomIn from '@/components/icons/ZoomIn.vue'
import ZoomOut from '@/components/icons/ZoomOut.vue'

const skribbleIcons = {
  dummy: { component: IconDummy },
  add_small: { component: AddSmall },
  address: { component: Address },
  a_add: { component: Aadd },
  a_chat: { component: AChat },
  a_delete: { component: Adelete },
  admin_guide: { component: AdminGuide },
  a_edit: { component: AEdit },
  a_star: { component: AStar },
  a_star_remove: { component: AStarRemove },
  a_sync: { component: ASync },
  account_disabled: { component: AccountDisabled },
  add_person: { component: AddPerson },
  archive: { component: Archive },
  arrow_up: { component: ArrowUp },
  arrow_up_right: { component: ArrowUpRight },
  arrow_down: { component: ArrowDown },
  arrow_right: { component: ArrowRight },
  chevron_up: { component: ChevronUp },
  arrow_long: { component: ArrowLong },
  arrow_first_page: { component: ArrowFirstPage },
  arrow_last_page: { component: ArrowLastPage },
  artboard: { component: Artboard },
  attachment: { component: Attachment },
  attachments_settings: { component: AttachmentsSettings },
  at: { component: At },
  auto_delete: { component: AutoDelete },
  back_to_desktop: { component: BackToDesktop },
  ban: { component: Ban },
  bank: { component: Bank },
  bank_ident: { component: BankIdent },
  bell: { component: Bell },
  bin: { component: Bin },
  browser_redirect: { component: BrowserRedirect },
  bullet: { component: Bullet },
  business_account: { component: BusinessAccount },
  business_aes: { component: BusinessAES },
  business_docs: { component: BusinessDocs },
  business_profile: { component: BusinessProfile },
  card: { component: Card },
  c_add: { component: CAdd },
  c_add_full: { component: CAddFull },
  c_add_outline: { component: CAddOutline },
  c_add_small: { component: CAddSmall },
  cached: { component: Cached },
  calendar_date: { component: CalendarDate },
  cancel: { component: Cancel },
  card_update: { component: CardUpdate },
  changelog: { component: Changelog },
  check: { component: Check },
  c_check: { component: CCheck },
  c_check_big: { component: CCheckBig },
  checkmark_big_circle: { component: CCheckmarkBigCircle },
  chop_circle: { component: ChopCircle },
  chop_circle_full: { component: ChopCircleFull },
  c_close: { component: CClose },
  checkbox_active: { component: CheckboxActive },
  checkbox_inactive: { component: CheckboxInactive },
  checkbox_indeterminate: { component: CheckboxIndeterminate },
  check_small: { component: CheckSmall },
  circle_dot: { component: CircleDot },
  circle_profile: { component: CircleProfile },
  circle_simple_up: { component: CircleSimpleUp },
  clear: { component: Clear },
  clear_outline: { component: ClearOutline },
  clear_small: { component: ClearSmall },
  clock: { component: Clock },
  close_x: { component: CloseX },
  contact_email: { component: ContactEmail },
  continue_sr: { component: ContinueSR },
  copy: { component: Copy },
  copy_content: { component: CopyContent },
  copy_sr: { component: CopySr },
  coupon_tag: { component: CouponTag },
  c_question: { component: CQuestion },
  credit_card: { component: CreditCard },
  csv_file: { component: CsvFile },
  currency_exchange: { component: CurrencyExchange },
  data_download: { component: DataDownload },
  data_download_outline: { component: DataDownloadOutline },
  delegate: { component: Delegate },
  delegate_user: { component: DelegateUser },
  design: { component: Design },
  developers: { component: Developers },
  document: { component: Document },
  document_outline: { component: DocumentOutline },
  document_search: { component: DocumentSearch },
  document_page: { component: DocumentPage },
  document_to_sign: { component: DocumentToSign },
  dots: { component: Dots },
  draft: { component: Draft },
  drafts_empty: { component: DraftsEmpty },
  eidplus: { component: Eidplus },
  email: { component: Email },
  email_settings_all: { component: EmailSettingsAll },
  email_settings_important: { component: EmailSettingsImportant },
  email_settings_none: { component: EmailSettingsNone },
  enter: { component: Enter },
  e_remove: { component: ERemove },
  expand_close: { component: ExpandClose },
  expand_more: { component: ExpandMore },
  expand_open: { component: ExpandOpen },
  eye_open: { component: EyeOpen },
  ezug: { component: EZug },
  f_dashboard: { component: FDashboard },
  feedback: { component: IconFeedback },
  file_text: { component: FileText },
  filter: { component: Filter },
  fit_height: { component: FitHeight },
  fit_width: { component: FitWidth },
  folder_user: { component: FolderUser },
  free_to_sign: { component: FreeToSign },
  gear: { component: Gear },
  google: { component: Google },
  go_to_skribble: { component: GoToSkribble },
  grid: { component: Grid },
  happy_emoticon: { component: HappyEmoticon },
  help_center: { component: HelpCenter },
  help_circle: { component: HelpCircle },
  highlight_off: { component: HighlightOff },
  ic_more_horizontal: { component: IcMoreHorizontal },
  ident: { component: Ident },
  inbox_empty: { component: InboxEmpty },
  info: { component: Info },
  info_solid: { component: InfoSolid },
  integration: { component: Integration },
  invoice: { component: Invoice },
  invoice_download: { component: InvoiceDownload },
  keyboard_arrow_down: { component: KeyboardArrowDown },
  label: { component: Label },
  last_change: { component: LastChange },
  leave: { component: Leave },
  lightning_big: { component: LightningBig },
  list: { component: List },
  loudspeaker: { component: Loudspeaker },
  magnify: { component: Magnify },
  magnify_outline: { component: MagnifyOutline },
  mail: { component: Mail },
  menu: { component: Menu },
  microsoft: { component: Microsoft },
  minus_circle: { component: MinusCircle },
  more_vert: { component: MoreVert },
  more_vert_small: { component: MoreVertSmall },
  multiple: { component: Multiple },
  neutral_emoticon: { component: NeutralEmoticon },
  mobile_contact: { component: MobileContact },
  new_btn_desktop: { component: NewBtnDesktop },
  new_btn_mobile: { component: NewBtnMobile },
  next_signature: { component: NextSignature },
  no_credit_card: { component: NoCreditCard },
  observer: { component: Observer },
  option: { component: Option },
  open_in_new: { component: OpenInNew },
  padlock: { component: Padlock },
  padlock_square: { component: PadlockSquare },
  payment_method: { component: PaymentMethod },
  pay_to_sign: { component: PayToSign },
  payment_card: { component: PaymentCard },
  pencil: { component: Pencil },
  person_check: { component: PersonCheck },
  person_remove: { component: PersonRemove },
  person_several: { component: PersonSeveral },
  person_single: { component: PersonSingle },
  photo: { component: Photo },
  pro_plan: { component: ProPlan },
  radio_button_active: { component: RadioButtonActive },
  radio_button_inactive: { component: RadioButtonInactive },
  referral: { component: Referral },
  refresh: { component: Refresh },
  remove: { component: Remove },
  replace: { component: Replace },
  reply: { component: Reply },
  reset: { component: Reset },
  ruler_pen: { component: RulerPen },
  sad_emoticon: { component: SadEmoticon },
  seal: { component: Seal },
  search: { component: Search },
  search_not_found: { component: SearchNotFound },
  search_error: { component: SearchError },
  seat_full: { component: SeatFull },
  seat_signer: { component: SeatSigner },
  single_copy: { component: SingleCopy },
  summary: { component: Summary },
  support_hotline: { component: SupportHotline },
  sparkles: { component: Sparkles },
  signature: { component: Signature },
  signature_crossed: { component: SignatureCrossed },
  signature_standards: { component: SignatureStandards },
  signing_failure: { component: SigningFailure },
  security: { component: Security },
  send_message: { component: SendMessage },
  setup_money: { component: SetupMoney },
  setup_options: { component: SetupOptions },
  sort_arrow: { component: SortArrow },
  square: { component: Square },
  starter_plan: { component: StarterPlan },
  swissid: { component: Swissid },
  system_preferences: { component: SystemPreferences },
  to_sign: { component: ToSign },
  trustid: { component: TrustId },
  team_plan: { component: TeamPlan },
  ungroup: { component: Ungroup },
  upgrade_arrow: { component: UpgradeArrow },
  users_group: { component: UsersGroup },
  users_add: { component: UsersAdd },
  user_edit: { component: UserEdit },
  verification_document: { component: VerificationDocument },
  video_play: { component: VideoPlay },
  video_tutorials: { component: VideoTutorials },
  warning: { component: Warning },
  visibility: { component: IconVisibility },
  visibility_off: { component: IconVisibilityOff },
  wallet: { component: Wallet },
  withdraw: { component: Withdraw },
  zoom: { component: Zoom },
  zoom_in: { component: ZoomIn },
  zoom_out: { component: ZoomOut },
}

const customIcons: IconSet = {
  component: (props: IconProps) =>
    h(typeof props.icon === 'string' ? skribbleIcons[props.icon]?.component : skribbleIcons.dummy.component),
}

export default defineNuxtPlugin({
  name: 'vuetify',
  dependsOn: ['i18n'],
  hooks: {
    'vuetify:before-create'({ vuetifyOptions }) {
      const { $i18nInstance } = useNuxtApp()

      const adapter = createVueI18nAdapter({ i18n: $i18nInstance, useI18n })

      vuetifyOptions.icons = {
        defaultSet: 'mdi',
        sets: { custom: customIcons, mdi },
        aliases,
      }

      vuetifyOptions.locale = {
        adapter,
      }
    },
  },
})
